import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const processDesignHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: options([
      { value: 'Deployed', name: 'Deployed' },
      { value: 'Suspended', name: 'Suspended' },
      { value: 'Resumed', name: 'Resumed' },
      { value: 'Replaced', name: 'Replaced' },
    ]).describe('What happened to the process design'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    processDesignId: z.uuid().hidden().describe('Foreign key to ProcessDesign'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    processDesign: belongsTo('ProcessDesign'),

    tenant: references('Tenant'),
  })
  .describe("Records each significant event in a process design's lifecycle")
  .as('ProcessDesignHistory');

export { processDesignHistory as processDesignHistorySchema };
